// 传给taro组件的swiper组件
import { Swiper, SwiperRef } from "antd-mobile";
import React from "react";

/**
 * props.autoplay
 * props.children
 * props.circular
 * props.current
 * props.indicatorDots
 * props.vertical
 * props.stuckAtBoundary
 * props.slideSize
 * props.style
 * props.onChange
 * props.useIndexChanged
 * props.itemCount
 */
const ReplaceSwiperComp = React.forwardRef<any, any>((props, ref) => {
  if (!props.children || (Array.isArray(props.children) && props.children.length === 0)) {
    return null;
  }

  const swiperRef = React.useRef<any>(null);

  React.useEffect(() => {
    ((ref as any) ?? swiperRef)?.current?.swipeTo(props.current ?? 0);
  }, [props.current]);
  // console.error("replaceSwiperComp", props);
  return (
    <Swiper
      className="replaceSwiperComp"
      ref={r => {
        swiperRef.current = r;
        if (ref) {
          (ref as any).current = r;
        }
      }}
      defaultIndex={props.current}
      indicator={props.indicatorDots}
      autoplay={props.autoplay}
      loop={props.circular}
      direction={props.vertical ? "vertical" : "horizontal"}
      stuckAtBoundary={props.stuckAtBoundary}
      slideSize={props.slideSize}
      style={props.style}
      onIndexChange={idx => {
        props.onChange?.({ detail: { current: idx } });
      }}>
      {props.children.map((item: any) => (
        <Swiper.Item key={item}>{item}</Swiper.Item>
      ))}
    </Swiper>
  );
});

export default ReplaceSwiperComp;
